import './styles/HaloFoundation.css';
import './styles/HaloBase.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { getAppRouter } from './lib/app-router';
import {AuthProvider} from './lib/auth';
import './styles/global.css';

const router = getAppRouter();
createRoot(document.getElementById('root')!).render(<StrictMode><AuthProvider><RouterProvider router={router} /></AuthProvider></StrictMode>);
